$(function() {
    $('#cities').tagsinput();
  });